import { setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { SWReactIcons } from "@similarweb/icons";

export const StyledButtonContainer = styled.div<{ isOpen: boolean }>`
    width: 96%;
    cursor: pointer;
    align-items: center;
    display: flex;
    flex-direction: row;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background: ${({ isOpen }) => (isOpen ? colorsPalettes.carbon[0] : colorsPalettes.carbon[25])};
    justify-content: space-between;
    padding: 12px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])}
`;

export const StyledRightPart = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledCountWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 8px;
`;

export const StyledTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledIcon = styled(SWReactIcons)`
    margin-left: 8px;
`;
